export default class IFrameHandler {
  constructor() {
    parent.postMessage({ type: 'load' }, window.iframeOrigin);

    this.mainwrapper = document.getElementById('mainwrapper');
    this.timer = setInterval(this.refreshContentHeight, 200);
    this.contentHeight = this.mainwrapper.clientHeight;

    this.sendHeightInterval();
    this.bindFullscreenButtons();

    window.addEventListener(
      'message',
      event => {
        this.onMessage(event);
      },
      false
    );
  }

  refreshContentHeight() {
    try {
      let newHeight = this.mainwrapper.clientHeight;

      if (document.querySelector('a.overlay-link')) {
        newHeight = Math.max(806, newHeight);
      }

      newHeight = Math.max(newHeight, document.getElementById('fancybox-wrap').clientHeight);

      if (newHeight !== null && newHeight != this.contentHeight && newHeight !== 0) {
        this.contentHeight = newHeight;
        parent.postMessage({ type: 'height', height: this.contentHeight }, window.iframeOrigin);
      }
    } catch (e) {
      console.error(e);
    }
  }

  sendHeightInterval() {
    setInterval(function () {
      parent.postMessage({ type: 'height', height: this.contentHeight }, window.iframeOrigin);
    }, 1000);
  }

  bindFullscreenButtons() {
    const fullscreenBtn = document.getElementById('fullscreen');
    const closeFullscreenBtn = document.getElementById('close-fullscreen');

    if (fullscreenBtn) {
      fullscreenBtn.onclick = function () {
        parent.postMessage({ type: 'fullscreen', fullscreen: true }, window.iframeOrigin);
      };
    }

    if (closeFullscreenBtn) {
      closeFullscreenBtn.onclick = function () {
        parent.postMessage({ type: 'fullscreen', fullscreen: false }, window.iframeOrigin);
      };
    }
  }

  onMessage(event) {
    const data = event.data;

    if (!data.hasOwnProperty('type')) return;

    switch (data.type) {
      case 'scroll':
        window.triggerFixedBarChange(data.scrollTop, data.height);
        break;

      default:
        break;
    }
  }
}

export { IFrameHandler };
